module.exports = __webpack_public_path__ + "static/FloatingFile-1-dark-cb2be3b89a1e9de6317b1eb555ae9d28.svg";